
import cmsBlock from '~/mixins/cmsBlock'

export default {
  name: 'CmsMediclub3Fallback',
  mixins: [cmsBlock],

  data () {
    return {
      fallbackContent: {
        title: 'Hold tight!',
        breadcrumb: 'BREADCRUMB',
        subtitle: 'Our website is getting a makeover and will be back looking fabulous shortly!',
        color: '#115585',
        gradient1: 'rgba(7, 119, 186, 0.9)',
        gradient2: 'rgba(0, 73, 149, 0.9)',
        lineQest: '#3284b3',
        text: '#ffffff',
        bgColol: '#4882a1',
        img: 'https://purepng.com/public/uploads/large/under-construction-1bj.png',
        isReady: false,
      },
    }
  },
}
